import styled from 'styled-components';

export const InvestmentTargetDatesDrawerStyles = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;

	.selected-dates-preview {
		margin-top: 1.5rem;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		border-radius: 0.5rem;
		padding: 1rem;
		background: ${({ theme }) => theme.v3.colors.gray[0]};
	}

	.days-container {
		flex: 1 1 33.33%;
	}

	.date-text {
		flex: 1 1 33.33%;
		white-space: nowrap;
	}

	.separator {
		width: 31px;
		height: 1px;
		background: ${({ theme }) => theme.v3.colors.gray[4]};
	}

	.badge {
		flex-shrink: 0;
	}
`;
